__turbopack_context__.v({
  "actions": "IHDqVG_actions",
  "actions__button-icon": "IHDqVG_actions__button-icon",
  "receipt": "IHDqVG_receipt",
  "receipt__header": "IHDqVG_receipt__header",
  "receipt__section": "IHDqVG_receipt__section",
  "receipt__section-content": "IHDqVG_receipt__section-content",
  "receipt__section-item": "IHDqVG_receipt__section-item",
  "receipt__section-item-value--capitalized": "IHDqVG_receipt__section-item-value--capitalized",
  "receipt__section-title": "IHDqVG_receipt__section-title",
});
